import React from 'react'
import cx from 'classnames'

import s from './Text.scss'

const sizes = [
  '64-76',
  '54-64',
  '36-43',
  '30-36',
  '24-28',
  '22-26',
  '20-24',
  '18-24', // remove after polk done
  '18-21',
  '16-19',
  '14-17',
  '12-14',
  '10-11',
]

const colors = [
  'brand',
  'white',
  'white-80',
  'white-40',
  'blue',
  'blue-80',
  'blue-40',
  'blueDark',
  'purpleDark',
  'purple',
  'red',
  'redBright',
  'gray',
  'darkGray',
  'darkRed',
  'black',
  'green',
  'greenLight',
  'greenBright',
  'greenExtraBright',
  'inherit',
  'orange',
]

// 8, 16, 24, 32
const Text = (props) => {
  const {
    className, tag = 'div', color = 'black', size, uppercase, center, right, cursor, message, noWrap, underline,
    weight, semibold, align, capitalize,
    onClick, ...rest
  } = props
  return (
    React.createElement(tag, {
      className: cx(className, {
        [s.xs]: size === 'xs',
        [s.sm]: size === 'sm',

        [s[`size-${size}`]]: (
          size
          && size !== 'xs'
          && size !== 'sm'
          // && sizes.includes(size)
        ),

        [s.semibold]: weight === 'semibold' || semibold,
        [s.bold]: weight === 'bold',

        [s.uppercase]: uppercase,
        [s.center]: center,
        [s.right]: right,
        [s.pointer]: cursor === 'pointer' || onClick,
        [s.capitalize]: capitalize,
        [s.underline]: underline,

        [s[color]]: colors.includes(color),
        [s[align]]: align,

        [s.noWrap]: noWrap,
      }),
      onClick,
      dangerouslySetInnerHTML: { __html: message },
      ...rest,
    })
  )
}


export default React.memo(Text)
